import React, { useEffect, useState } from 'react';
import SelectInput from '../../controls/selectInput';
import { apiPost } from '../../services/apiClient';

const ClientManagerInput = (params) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		apiPost('admin/companies/ref/clientManagers')
			.then(data => {
				setOptions(data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; }));
			})
			.catch(err => {
				console.log(err)
			});
	}, []);

	return (
		<SelectInput
			{...params}
			className="issue-status-input"
			value={params.value && params.value.value}
			options={options}
		/>
	);
}

export default ClientManagerInput;


// WEBPACK FOOTER //
// ./App/grids/controls/clientManagerInput.jsx